import type { Maybe, ValueOf } from '../../types/base/';

export const buttonSizes = {
  SMALL: 'small',
  /** default value */
  REGULAR: 'regular',
  LARGE: 'large',
} as const;
export type ButtonSize = ValueOf<typeof buttonSizes>;

export const buttonTypes = {
  /** default value */
  NEUTRAL: 'neutral',
  PRIMARY: 'primary',
  DESTRUCTIVE: 'destructive',
} as const;
export type ButtonType = ValueOf<typeof buttonTypes>;

export const buttonNativeTypes = {
  BUTTON: 'button',
  SUBMIT: 'submit',
  RESET: 'reset',
} as const;
export type ButtonNativeType = ValueOf<typeof buttonNativeTypes>;

export const buttonFrames = {
  /** default value */
  FULL: 'full',
  GHOST: 'ghost',
  NONE: 'none',
} as const;
export type ButtonFrame = ValueOf<typeof buttonFrames>;

export const buttonIconPositions = {
  /** default value */
  LEFT: 'left',
  RIGHT: 'right',
} as const;
export type ButtonIconPosition = ValueOf<typeof buttonIconPositions>;

export const buttonTargets = {
  BLANK: '_blank',
  SELF: '_self',
  PARENT: '_parent',
  TOP: '_top',
} as const;
export type ButtonTarget = Maybe<ValueOf<typeof buttonTargets>>;

export const buttonRels = {
  EXTERNAL: 'external',
} as const;
export type ButtonRel = Maybe<string | ValueOf<typeof buttonRels>>;
